module.exports = __webpack_public_path__ + "static/media/dynamic_segments_sparkle.906efaa3.svg";